import { useState } from "react";
import { useScale } from "common/utils";

// モダンな入力フィールド
export const MobileInput = ({
  type = "text",
  value,
  onChange,
  placeholder,
  label,
  disabled = false,
  maxLength,
  className = "",
}: {
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  maxLength?: number;
  className?: string;
}) => {
  const { height } = useScale();
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === "password";
  const inputType = isPasswordField && showPassword ? "text" : type;

  return (
    <div className={`w-full flex-col-el space-y-3 ${className}`}>
      {label && height > 648 && (
        <label className="text-caption2 text-textcolor-black">{label}</label>
      )}
      <div className="w-full flex-col-center relative">
        <input
          type={inputType}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full box-border py-4 rounded-2xl text-body2 text-base transition-all duration-300 text-textcolor-black bg-gradient-to-br from-white/80 to-white/60 border-2 border-white/30 shadow-sm ${
            isPasswordField ? "px-4 pr-12" : "px-4"
          }`}
          disabled={disabled}
          maxLength={maxLength}
        />
        {isPasswordField && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute bg-transparent border-none outline-none shadow-none right-3 top-1/2 transform -translate-y-1/2 p-1"
            disabled={disabled}
          >
            <span className="material-symbols-outlined text-gray-500 text-xl">
              {showPassword ? "visibility_off" : "visibility"}
            </span>
          </button>
        )}
      </div>
    </div>
  );
};
